import styles from "components/my-bets/styles.module.css";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text.tsx";
import React from "react";
import { JoinedContest } from "interfaces/leaderboard/contest.ts";
import { JoinedContestItem } from "components/contests/contest-display-items";
import { useAppSelector } from "state/hooks.ts";
import { getContestsState } from "state/slices/contests-slice.ts";

const MyContests = () => {
  const contestsState = useAppSelector(getContestsState);

  const joinedContests = contestsState.joinedContests;

  const hasContests = joinedContests.length > 0;

  if (!hasContests) {
    return (
      <div className={styles.noBetsTextContainer}>
        <BlockyHeavyText>You haven't joined any contests yet</BlockyHeavyText>
      </div>
    );
  }

  // Sort joinedContests by the most recent created_at date from their entries
  const sortedJoinedContests = [...joinedContests].sort((a, b) => {
    // Get the most recent created_at date from each contest's entries
    const getLatestEntryDate = (contest: JoinedContest): Date => {
      if (!contest.entries || contest.entries.length === 0) return new Date(0);
      
      // Find the most recent entry by comparing created_at dates
      const latestEntry = contest.entries.reduce((latest, current) => {
        const latestDate = new Date(latest.created_at);
        const currentDate = new Date(current.created_at);
        return currentDate > latestDate ? current : latest;
      }, contest.entries[0]);
      
      return new Date(latestEntry.created_at);
    };
    
    const dateA = getLatestEntryDate(a);
    const dateB = getLatestEntryDate(b);
    
    // Sort in descending order (most recent first)
    return dateB.getTime() - dateA.getTime();
  });

  return (
    <>
      {sortedJoinedContests.map((joinedContest: JoinedContest) => (
        <JoinedContestItem key={joinedContest.contest_id} joinedContest={joinedContest} />
      ))}
    </>
  );
};

export default MyContests;